export class SiteConfigModel {
  aboutOneLiner: string = '';
  contactEmail: string = '';
  elasticSearchIndex: string = '';
  esReportIndex: string = '';
  facebookAppId: string = '';
  facebookImage: string = '';
  facebookLink: string = '';
  footerLinkConfig?: { [key: string]: { title: string; links: string[] } }[] = [];
  loadingImageUrl: string = '';
  machineName: string = '';
  headerImageUrl: string = '';
  primaryBaseUrl: string = '';
  primaryElasticSearchIndex: string = '';
  primaryMachineName: string = '';
  primarySite: boolean = false;
  providedBy: string = '';
  sendGridApiEndpoint: string = '';
  sendGridApiRecipients: string = '';
  sideMenuImageUrl: string = '';
  siteName: string = '';
  siteTitleSuffix: string = '';
  siteUrl: string = '';
  tagLine: string = '';
  twitterImage: string = '';
  twitterLink: string = '';
  twitterUsername: string = '';

  constructor(data: any) {
    if (data.aboutOneLiner) {
      this.aboutOneLiner = data.aboutOneLiner;
    }

    if (data.contactEmail) {
      this.contactEmail = data.contactEmail;
    }

    if (data.elasticSearchIndex) {
      this.elasticSearchIndex = data.elasticSearchIndex;
    }

    if (data.esReportIndex) {
      this.esReportIndex = data.esReportIndex;
    }

    if (data.facebookAppId) {
      this.facebookAppId = data.facebookAppId;
    }

    if (data.facebookImage) {
      this.facebookImage = data.facebookImage;
    }

    if (data.facebookLink) {
      this.facebookLink = data.facebookLink;
    }

    if (data.footerLinkConfig) {
      this.footerLinkConfig = data.footerLinkConfig;
    }

    if (data.loadingImageUrl) {
      this.loadingImageUrl = data.loadingImageUrl;
    }

    if (data.machineName) {
      this.machineName = data.machineName;
    }

    if (data.headerImageUrl) {
      this.headerImageUrl = data.headerImageUrl;
    }

    if (data.primaryBaseUrl) {
      this.primaryBaseUrl = data.primaryBaseUrl;
    }

    if (data.primaryElasticSearchIndex) {
      this.primaryElasticSearchIndex = data.primaryElasticSearchIndex;
    }

    if (data.primaryMachineName) {
      this.primaryMachineName = data.primaryMachineName;
    }

    if (data.primarySite) {
      this.primarySite = data.primarySite;
    }

    if (data.providedBy) {
      this.providedBy = data.providedBy;
    }

    if (data.sendGridApiEndpoint) {
      this.sendGridApiEndpoint = data.sendGridApiEndpoint;
    }

    if (data.sendGridApiRecipients) {
      this.sendGridApiRecipients = data.sendGridApiRecipients;
    }

    if (data.sideMenuImageUrl) {
      this.sideMenuImageUrl = data.sideMenuImageUrl;
    }

    if (data.siteName) {
      this.siteName = data.siteName;
    }

    if (data.siteTitleSuffix) {
      this.siteTitleSuffix = data.siteTitleSuffix;
    }

    if (data.siteUrl) {
      this.siteUrl = data.siteUrl;
    }

    if (data.tagLine) {
      this.tagLine = data.tagLine;
    }

    if (data.twitterImage) {
      this.twitterImage = data.twitterImage;
    }

    if (data.twitterLink) {
      this.twitterLink = data.twitterLink;
    }

    if (data.twitterUsername) {
      this.twitterUsername = data.twitterUsername;
    }
  }
}
